var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('switch-field',_vm._b({model:{value:(_vm.include),callback:function ($$v) {_vm.include=$$v},expression:"include"}},'switch-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }